export default {"src":"/_next/static/media/logo_pink.49f1e279.svg","height":232,"width":787,"blurWidth":0,"blurHeight":0};